@import (reference) '../../../constants/spacing.module.less';

.base-banner {
  border: 1px solid var(--banner-v2-border-color);
  background: var(--banner-v2-background-color);

  .icon {
    color: var(--banner-v2-icon-color);
  }
}

.full-banner {
  display: flex;
  align-items: flex-start;
  gap: @space-8;
  padding: @space-16;

  .banner-content-container {
    justify-content: flex-start;
    gap: @space-8;
  }

  .banner-content {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    gap: @space-8;
    &.content-with-divider {
      padding-left: @space-12;
      border-left: 1px solid var(--banner-v2-border-color);
    }
  }

  .buttons-container {
    gap: @space-16;
  }
}

.default-banner {
  display: flex;
  align-items: center;
  gap: @space-8;
  padding: 7px; // Explicitly outside of the spacing variables to account for the 1px border

  .banner-content-container {
    gap: @space-8;
    justify-content: center;
    flex-flow: row nowrap;
  }

  .banner-content {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: @space-8;
  }

  .buttons-container {
    gap: @space-8;
  }

  .has-close-button {
    padding-left: @space-36; // 24px for dismiss button + 12px for left margin
  }
}

.inline-banner,
.tiny-banner {
  display: flex;
  align-items: center;
  gap: @space-4;
  padding: @space-4 @space-8;
  border-radius: @space-4;

  .banner-content-container {
    justify-content: flex-start;
    gap: @space-4;
    flex-flow: row nowrap;
    height: 24px;
  }

  .banner-content {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: @space-4;
  }

  .buttons-container {
    gap: @space-4;
  }

  .icon > svg {
    display: flex;
    justify-content: center;

    height: 18px;
    width: 18px;
  }
}

.tiny-banner {
  .banner-content-container {
    height: 18px;
  }

  .banner-content {
    font-size: 14px;
  }
}

.info-banner {
  --banner-v2-border-color: var(--primary--message--border-color--4);
  --banner-v2-background-color: var(--primary--message--background-color--2);
  --banner-v2-icon-color: var(--primary--icon--background-color--1);
}

.warning-banner {
  --banner-v2-border-color: var(--warning--message--border-color--4);
  --banner-v2-background-color: var(--warning--message--background-color--1);
  --banner-v2-icon-color: var(--warning--icon--fill-color--1);
}

.error-banner {
  --banner-v2-border-color: var(--error--message--border-color--4);
  --banner-v2-background-color: var(--error--message--background-color--1);
  --banner-v2-icon-color: var(--error--icon--fill-color--1);
}

.featured-banner {
  --banner-v2-border-color: var(--purple-8D30F7);
  --banner-v2-background-color: var(--purple-F6F2FF);
}

.success-banner {
  --banner-v2-border-color: var(--success--border-color--1);
  --banner-v2-background-color: var(--green-EEFFF5);
  --banner-v2-icon-color: var(--green-10844C);
}

.banner-content-container {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
}

.icon {
  display: flex;
  align-items: center;
  height: 24px;
  width: 24px;
  padding: 0 3px;

  flex-shrink: 0;
}

.buttons-container {
  display: flex;
  align-items: center;
}

.close-button {
  color: var(--default--icon--fill-color--3);
}
